import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

interface CustomProps {
  $active?: boolean;
  $customStyles?: any;
}
  

export const NavLinkWrapper = styled.div<CustomProps>`    
  .link {
    text-decoration:none !important;
    padding-left:10px;
    padding-top:7px;
    padding-right:10px;
    padding-bottom:7px;
    border-radius:5px;        
    cursor:pointer;
    display:flex;
    align-items:center;
    width: 100%;
    gap: 8px;
    text-decoration: none;
    background: transparent;
    ${props => props.$active ? `
      background: #4E4E4E;
      span{
        color:${theme.colors.white};
      }
      svg{
        fill:${theme.colors.white} !important;
        path{
          fill:${theme.colors.white} !important;
        }
      }
    `:``}
    &:hover{
      background:#4E4E4E;
      span{
        color:${theme.colors.white};
      }
      svg{
        fill:${theme.colors.white} !important;
        path{
          fill:${theme.colors.white} !important;
        }
      }
    }
  }
`

export const LinkText = styled.span<CustomProps>`
  font-size:14px;
  font-weight:400;
  font-family:"Rubik";
  color:${props => props.$active ? theme.colors.white : "#BFBFBF"};
`